/*@ngInject*/
const GetUserListRepository = function ($q, baseRepository, userUtil) {

    angular.extend(this, baseRepository);

    const closeUserPersistentConnectionPromises = {};

    this.loadUserList = function (params) {
        const url = '/rest/User/List',
            config = {
                params: {
                    userName: params.searchString,
                    userType: params.userType,
                    activeOnly: params.hideInactiveUsers,
                    adminUsersOnly: params.adminUsersOnly,
                    startIndex: params.startIndex,
                    numberOfRows: params.pageSize,
                    sortBy: params.key,
                    sortDirection: params.sortType
                }
            };

        return this.get(url, config);
    };

    this.createNewUser = function (userType) {
        const url = '/rest/User/createUser',
            body = {},
            config = {
                params: {
                    userType: userType,
                    organizationId: 15
                }
            };

        return this.post(url, body, config);
    };

    this.loadUserActions = function (userType, userId) {
        const url = '/rest/Actions',
            config = {
                params: {
                    uri: userUtil.getOwnerUri(userType, userId),
                    registrationIdentifier: !_.isNil(userId) ? '/User/' + userId : null
                }
            };

        return this.get(url, config);
    };

    this.loadUserById = function (userId) {
        const url = `/rest/User/${userId}`,
            config = {
                params: {
                    registrationIdentifier: `/User/${userId}`
                }
            },
            closeUserPersistentConnectionPromise = closeUserPersistentConnectionPromises[userId] || $q.when();

        return closeUserPersistentConnectionPromise.then(() => {
            return this.get(url, config);
        });
    };

    this.getUserRolesById = function (userId) {
        const url = `/rest/User/${userId}/roles`;
        return this.get(url);
    };

    this.closeUserPersistentConnection = function (userId) {
        const url = `/rest/User/${userId}/List`,
            config = {
                params: {
                    registrationIdentifier: `/User/${userId}`
                }
            },
            promise = this.delete(url, config);

        closeUserPersistentConnectionPromises[userId] = promise;

        return promise;
    };

    this.upgradeForms = function (userId) {
        const url = `/rest/User/${userId}/upgradeForms`;
        return this.post(url);
    };

    this.getForms = function (userId) {
        const url = `/rest/User/${userId}/formSummaries`;
        return this.get(url);
    };
};

angular.module('umCore')
    .service('userRepository', GetUserListRepository);
